import { useEffect, useRef, useState } from "react";
import AssetOrderDetailViewMainContainer from "./AssetOrderDetailViewMainContainer"
import { useSelector } from "react-redux";

const AssetOrderDetailViewMainContainer_Container = () => {
    const wrapperRef = useRef<any>(null);
    const [selectedKey, setSelectedKey] = useState("requisition");
    const [showFleetBreadcrumb, setShowFleetBreadcrumb] = useState(false);
    const [tabSwitchClicked, setTabSwitchClicked] = useState(false)
    const [tab, setTab] = useState('')
    const handleLinkClick = (item?: any) => {
      if (item) {
        if(item.props.itemKey === 'fleet-processing'){
          setSelectedKey(item.props.itemKey);
          setTab(item.props.itemKey)
          setShowFleetBreadcrumb(true)
          setTabSwitchClicked(false)
        } else {
          const fleetBreadCrumb = item.props.itemKey !== 'requisition'
          setTab(item.props.itemKey)
          setShowFleetBreadcrumb(fleetBreadCrumb)
          setTabSwitchClicked(true)
        }
      }
    };
    
    const activeNavigation = useSelector((state: any) => state.nav.nav)

    useEffect(() => {
        document.getElementsByClassName('content-wrapper')[0].scrollTop = 0;
    }, [activeNavigation]);

    return (
        <AssetOrderDetailViewMainContainer 
        wrapperRef={wrapperRef} 
        setSelectedKey={setSelectedKey}
        selectedKey={selectedKey} 
        showFleetBreadcrumb={showFleetBreadcrumb} 
        handleLinkClick={handleLinkClick}
        tabSwitchClicked={tabSwitchClicked}
        setTabSwitchClicked={setTabSwitchClicked}
        setShowFleetBreadcrumb={setShowFleetBreadcrumb}
        tab={tab}
        />
    )
}

export default AssetOrderDetailViewMainContainer_Container